export default function customLoader(props: any) {
  return props.src;
}
